/// <reference path='Dapi.d.ts' />
export default function observeLocation(win, dapi) {
    win.addEventListener("hashchange", () => {
        // according to https://developer.mozilla.org/de/docs/Web/API/WindowEventHandlers/onpopstate 
        // win.onpopstate should be triggered if the active entry changes between to entries for the same document. That is it should be triggered if the hash changes.
        // Sadly this is only the case in Chrome and FF but not in IE.
        dapi.publishLocation(win.location.href);
    });
}
